import { render, staticRenderFns } from "./FrequentQuestionBox.vue?vue&type=template&id=3075bd29&"
import script from "./FrequentQuestionBox.js?vue&type=script&lang=js&"
export * from "./FrequentQuestionBox.js?vue&type=script&lang=js&"
import style0 from "./FrequentQuestionBox.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports